import {useTranslation} from "react-i18next";
import NavBreadcrum from "components/NavBreadcrum";
import MenuButtons from "components/MenuButtons";
import navs from "./navs";


const MainReports = () => {

  const [t] = useTranslation("routes")

  const bread = [
    {name: t("labels.reports"), current: true}
  ]

  return (
    <>
      <NavBreadcrum navs={navs} bread={bread}/>
      <MenuButtons navs={navs}/>
    </>
  )
}
export default MainReports;